import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
// @ts-ignore
import { AutomationId, AUTO_ATTR_KEY } from 'utils/automationUtil'

export const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const StyledSingleContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${({ mode }: { mode: Theme }) => sys[mode].common.divider[100]};
  padding: 8px 8px 0 8px;
  :last-child {
    border-bottom: none;
  }
  cursor: pointer;
`

export const StyledSingleTop = styled.div.attrs({
  [AUTO_ATTR_KEY]: AutomationId.popularlinks.topLink
})`
  /* line-clamp */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
  max-height: 44px;
  overflow: hidden;
  color: ${({ mode }: { mode: Theme }) => sys[mode].interaction.primary.default};
`

export const StyledSingleTopLink = styled.a`
  font-size: ${sys.typescale[14].size};
  font-weight: ${sys.fontWeight.medium};
  line-height: ${sys.typescale[14].lineHeight};
  color: ${({ mode }: { mode: Theme }) => sys[mode].interaction.primary.default};
  text-decoration: none;
  &:hover {
    color: ${({ mode }: { mode: Theme }) => sys[mode].interaction.primary.hover};
  }
  &:active {
    color: ${({ mode }: { mode: Theme }) => sys[mode].interaction.primary.pressed};
  }
`

export const StyledSingleBottom = styled.div`
  width: 100%;
  height: 32px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: 7px 0;
  gap: 8px;
`

export const StyledSingleBottomItem = styled.div.attrs({
  [AUTO_ATTR_KEY]: AutomationId.popularlinks.bottomItem
})`
  height: 100%;
  font-size: ${sys.typescale[12].size};
  font-weight: ${sys.fontWeight.regular};
  line-height: ${sys.typescale[12].lineHeight};
  color: ${({ mode }: { mode: Theme }) => sys[mode].text.placeholder};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const StyledSingleBottomItemHightlight = styled.span`
  width: max-content;
  font-size: ${sys.typescale[12].size};
  line-height: ${sys.typescale[12].lineHeight};
  font-weight: ${sys.fontWeight.semibold};
  color: ${({ mode }: { mode: Theme }) => sys[mode].text.primary};
`

export const StyledSingleBottomVerticalDivider = styled.div`
  border-left: 1px solid ${({ mode }: { mode: Theme }) => sys[mode].common.divider[100]};
  height: 100%;
`

export const StyledSingleBottomActionItems = styled.div`
  display: inline-flex;
  flex-grow: 1;
  width: max-content;
  height: 100%;
  align-items: center;
  padding-left: 8px;
  border-left: 1px solid ${({ mode }: { mode: Theme }) => sys[mode].common.divider[100]};
`

export const StyledOtherInfoContainer = styled.div`
  cursor: default;
`

export const StyledHideMentionsButtonContainer = styled.div`
  display: flex;
  padding: 8px 0 8px 12px;
  border-top: 1px solid ${({ mode }: { mode: Theme }) => sys[mode].common.divider[100]};
`

export const StyledHideMentionsButton = styled.div<{ mode: Theme }>`
  cursor: pointer;
  font-size: ${sys.typescale[14].size};
  font-weight: ${sys.fontWeight.regular};
  line-height: ${sys.typescale[14].lineHeight};
  color: ${({ mode }: { mode: Theme }) => sys[mode].interaction.primary.default};
  &:hover {
    color: ${({ mode }: { mode: Theme }) => sys[mode].interaction.primary.hover};
  }
  &:active {
    color: ${({ mode }: { mode: Theme }) => sys[mode].interaction.primary.pressed};
  }
`
